import { createContext } from "react";

// Lets a ModalTitle tell its parent Modal which element names the dialog.
export const ModalTitleContext = createContext<
  ((id: string | undefined) => void) | null
>(null);
